// src/components/PaymentForm.jsx
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Box,
} from "@mui/material";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

export default function PaymentForm({ email }) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    api
      .get(ENDPOINTS.getPlans())
      .then((res) => {
        if (res.data?.status === "Ok") {
          setPlans(res.data.data || []);
        }
      })
      .catch(() => setMessage("Failed to load plans"))
      .finally(() => setLoading(false));
  }, []);

  const startPayment = async (plan) => {
    const resolvedEmail =
      email || localStorage.getItem("email")?.toLowerCase() || "";

    if (!resolvedEmail) {
      setMessage("No email found. Please log in again.");
      return;
    }

    setMessage("Redirecting to checkout…");

    try {
      const res = await api.post(ENDPOINTS.createCheckout(), {
        email: resolvedEmail,
        itemPriceId: plan.planId,
      });

      if (!res.data?.url) {
        setMessage("Unable to start payment.");
        return;
      }

      window.location.href = res.data.url;
    } catch (err) {
      console.error("Payment error:", err);
      setMessage("Payment error. Please try again.");
    }
  };

  // Detect plan type and return the correct description
  const getPlanDescription = (plan) => {
    const id = plan.planId?.toLowerCase() || "";
    const name = plan.planName?.toLowerCase() || "";

    if (
      id.includes("year") ||
      id.includes("annual") ||
      name.includes("year") ||
      name.includes("annual")
    ) {
      return "⭐ Best Value (46% off / save $78 per year / equal to $7.50 per month)";
    }

    if (id.includes("quarter") || name.includes("quarter")) {
      return "21% off / only $11 per month";
    }

    if (id.includes("life") || name.includes("life")) {
      return "One payment. Lifetime membership.";
    }

    return "";
  };

  if (loading) {
    return <Typography>Loading plans…</Typography>;
  }

  return (
    <Box>
      <Typography variant="h6" fontWeight="bold" mb={0.5}>
        Membership Plans
      </Typography>
<Typography variant="p" pb={2}>Subscribe to continue submitting to casting opportunities after your free trial credits are used. Active members receive full access to submissions and casting notices.</Typography>
      <Grid container spacing={2}>
        {plans
          .filter((p) => p.price > 0)
          .map((plan) => {
            const isRecommended =
              plan.planId?.toLowerCase().includes("year") ||
              plan.planId?.toLowerCase().includes("annual");

            return (
              <Grid item xs={12} key={plan.id}>
                <Card
                  variant="outlined"
                  sx={{
                    borderColor: isRecommended ? "#1976d2" : "divider",
                    position: "relative",
                  }}
                >
                  {isRecommended && (
                    <Chip
                      label="⭐ Best Value"
                      color="primary"
                      size="small"
                      sx={{ position: "absolute", top: 8, right: 8 }}
                    />
                  )}

                  <CardContent>
                    <Typography variant="h6" fontWeight="bold">
                      {plan.planName}
                    </Typography>

                    <Typography color="text.secondary" mb={1}>
                      {plan.billingPeriod}
                    </Typography>

                    <Typography variant="h4" fontWeight="bold">
                      ${plan.price}
                    </Typography>

                    {getPlanDescription(plan) && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mt={0.5}
                        mb={2}
                      >
                        {getPlanDescription(plan)}
                      </Typography>
                    )}

                    <Button
                      fullWidth
                      variant={isRecommended ? "contained" : "outlined"}
                      onClick={() => startPayment(plan)}
                    >
                      Subscribe
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
      </Grid>

      <Typography
        mt={3}
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 520 }}
      >
        Memberships renew automatically based on the billing period selected. You may cancel or modify your membership at any time through your account settings in accordance with our Terms of Service.
Please note that the charge will appear as <a 
  href="https://www.NYCASTINGS.COM" 
  style={{ color: "#90b5fe" }}
  target="_blank"
  rel="noopener noreferrer"
>
  www.NYCASTINGS.COM
</a> on your bank or credit card statement.
      </Typography>

      {message && (
        <Typography mt={2} color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}
